export default "__VITE_ASSET__BOwTkYwX__"